import React from 'react';

interface GPOItem {
  name?: string;
  id?: string | number;
}

interface GPOCellProps {
  row: any;
  field: string;
}

const GPOCell: React.FC<GPOCellProps> = ({ row, field }) => {
  const gpos: GPOItem[] = row?.[field];

  if (!gpos || gpos.length === 0) {
    return null;
  }

  return (
    <div className="space-y-1">
      {gpos.map((item, index) => (
        <div key={item?.id || index} className="flex items-start">
          <span className="text-sm">{item?.name || 'n/a'}</span>
        </div>
      ))}
    </div>
  );
};

export default GPOCell;
